import { type Common } from '../../common.js';
import { type PaginatedQueryOptions } from '../../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../../models/pagination/PaginationResponse.type.js';
import type {
  CreateValues,
  EditResponse,
  FindAllOptions,
  TestPatient,
  UpdateValues,
} from '../../models/workflowTest/entity/patient.js';

export default class API {
  common: Common;
  baseEndpoint = '/workflow-test/entity/patient';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<TestPatient>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(ehrInformationId: string): Promise<EditResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}`);
    return await this.common.getJSON(url);
  }

  async findTestStatusById(ehrInformationId: string): Promise<TestPatient> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}/test-status`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<EditResponse> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async clone(ehrInformationId: string): Promise<EditResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}/clone`);
    return await this.common.postJSON(url, {});
  }

  async update(ehrInformationId: string, values: UpdateValues): Promise<EditResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}`);
    return await this.common.patchJSON(url, values);
  }
}
